import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/components/CoverMedia.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/node_modules/.pnpm/next@16.3.0_@babel+core@7.29.7_@types+node@20.19.43_react-dom@19.2.8_react@19.2.8__react@19.2.8/node_modules/next/dist/client/app-dir/link.js");
